import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import useCursorFlashlight from '../hooks/useCursorFlashlight';
import { useLayout } from '../context/LayoutContext';

interface MainLayoutProps {
  children: React.ReactNode;
}

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
`;

const BackgroundMedia = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
  overflow: hidden;
  
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const BackgroundOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => `${theme.colors.background}f0`}; /* Opacité à environ 94% */
  z-index: -1;
`;

const MainContent = styled.main`
  flex: 1;
  width: 100%;
  z-index: 2;
`;

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  // Référence pour l'élément vidéo
  const videoRef = useRef<HTMLVideoElement>(null);
  
  // Utiliser le hook pour l'effet de flashlight et le contexte de mise en page
  useCursorFlashlight();
  const { isMobile } = useLayout();

  // Effet pour réduire la vitesse de lecture de la vidéo
  useEffect(() => {
    if (videoRef.current) {
      // Définir la vitesse de lecture (0.75 = 75% de la vitesse normale)
      videoRef.current.playbackRate = 0.75;
      
      // Jouer la vidéo sur tous les appareils
      videoRef.current.play().catch(e => console.log('Autoplay prevented:', e));
    }
  }, []);

  return (
    <LayoutWrapper>
      <BackgroundMedia>
        <video ref={videoRef} autoPlay loop muted playsInline>
          <source src="/videos/data-animation.mp4" type="video/mp4" />
          <source src="/videos/data-animation.mkv" type="video/x-matroska" />
          {/* Fallback pour les navigateurs qui ne supportent pas ces formats vidéo */}
          Votre navigateur ne supporte pas la lecture de vidéos.
        </video>
      </BackgroundMedia>
      <BackgroundOverlay />
      <MainContent>{children}</MainContent>
    </LayoutWrapper>
  );
};

export default MainLayout;